export const RCMX_BLOG_URL = 'https://ba.rcmx.com'